import {
  abbreviate,
  Avatar,
  ColorMode,
  Flex,
  Header,
  Link,
  Popover,
  Switch,
  Text,
  TopNav,
} from '@revolut-internal/ui-kit'
import { FC } from 'react'

import { useUser } from 'containers/App'
import { useApp, useLayout } from 'containers/Bootstrap'
import { IDAVE_URL } from 'lib/auth'
import { getFullUserName } from 'lib/utils'

export const TopNavProfile: FC = () => {
  const { authService } = useApp()
  const { user } = useUser()
  const { themeMode, toggleThemeMode } = useLayout()

  const displayName = getFullUserName(user)

  return (
    <TopNav.Profile label={abbreviate(displayName)} uuid={user?.id}>
      {user && (
        <Header variant="item">
          <Header.Title>{displayName}</Header.Title>
          <Header.Subtitle>
            <Link href={`${IDAVE_URL}/users/${user.id}`} target="_blank">
              @{user.username}
            </Link>
          </Header.Subtitle>
          <Header.Avatar>
            <Avatar size={56} uuid={user.id} label={abbreviate(displayName)} />
          </Header.Avatar>
        </Header>
      )}

      <Popover.Group>
        {user && (
          <Popover.Item
            use="a"
            useIcon="Profile"
            href={`${IDAVE_URL}/users/${user.id}`}
            target="_blank"
          >
            My Profile
          </Popover.Item>
        )}

        <Popover.Item use="label" useIcon="Contrast">
          <Flex alignItems="center" justifyContent="space-between">
            <Text>Dark mode</Text>
            <Switch checked={themeMode === ColorMode.DARK} onChange={toggleThemeMode} />
          </Flex>
        </Popover.Item>
      </Popover.Group>

      <Popover.Group>
        <Popover.Item
          use="button"
          useIcon="LogoutDoor"
          color="danger"
          onClick={() => authService.signOut()}
        >
          Logout
        </Popover.Item>
      </Popover.Group>
    </TopNav.Profile>
  )
}
